module.exports = __webpack_public_path__ + "static/media/arrow_up.58f30b1f.svg";